import * as React from 'react';

interface IBottoneProps {
    Nome?: string;
    Testo: string;
    Default?: boolean;
    ClasseAttivo?: string;
    ClasseNonAttivo?: string;
    ClasseAttesa?: string;
    Attivo?: boolean;
    Attesa?: boolean;
    OnClick?: (sender: Bottone) => void;
    Dato?: any;
}

export class Bottone extends React.PureComponent<IBottoneProps, {}> {
    public static defaultProps: Partial<IBottoneProps> = {
        ClasseAttivo: "btn btn-brand",
        ClasseNonAttivo: "btn btn-info.brand",
        ClasseAttesa: "btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner kt-spinner--light kt-spinner--right",
        Attivo: true,
        Attesa: false,
        Default: false,
        Dato: undefined
    };

    constructor(props: any) {
        super(props);
    }

    private OnClick() {
        if (this.props.OnClick != undefined) {
            this.props.OnClick(this);
        }
    }

    public render() {
        let Classe: string = (this.props.Attesa ? this.props.ClasseAttesa : this.props.Attivo ? this.props.ClasseAttivo : this.props.ClasseNonAttivo) as string;
        return <button type={this.props.Default ? "submit" : "button"} className={Classe} onClick={(e) => { e.preventDefault(); this.OnClick(); }}>{this.props.Testo}</button>;
    }
}



// WEBPACK FOOTER //
// ./src/components/Bottone.tsx